import React from 'react';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';

import { actions } from '../../services/match';

import Avatar from '../../components/Avatar';
import Page from '../../components/Page';

import styled from './MatchStyles';

class Match extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.matchId !== this.props.match.params.matchId) {
      this.props.actions.load(this.props.match.params.matchId);
    }
  }

  componentWillMount() {
    this.props.actions.load(this.props.match.params.matchId);
  }

  renderHeader() {
    const { data, classes } = this.props;
    return (
      <Paper className={classes.header}>
        {this.renderProfileItem(data.user1)}
        <Typography className={classes.timeAgo}>
          {moment(new Date(data.createTime).toUTCString()).fromNow()}
        </Typography>
        {this.renderProfileItem(data.user2)}
      </Paper>
    );
  }

  renderProfileItem(userData) {
    const { classes } = this.props;
    return (
      <div className={classes.profileItem}>
        <ButtonBase component={Link} to={`/users/${userData._id}`}>
          <Avatar user={userData} size={120} />
        </ButtonBase>
        <Typography>{userData.firstName + ' ' + userData.lastName}</Typography>
      </div>
    );
  }

  renderMessageItem(message) {
    const { data, classes } = this.props;

    let fromUser, side;
    if (message.fromUser === data.user1._id) {
      fromUser = data.user1;
      side = 'left';
    } else {
      fromUser = data.user2;
      side = 'right';
    }
    return (
      <div key={message._id} className={classnames(classes.message, side)}>
        <div className={classnames(classes.messageAvatar, side)}>
          <Avatar user={fromUser} size={50} />
          <Typography variant="caption">{fromUser.firstName}</Typography>
        </div>
        {message.type === 'text' ? (
          <div className={classes.messageText}>
            <Typography variant="body1">{message.message}</Typography>
            <Typography variant="caption" className={classes.timeAgoMsg}>
              {moment(new Date(message.createTime).toUTCString()).fromNow()}
            </Typography>
          </div>
        ) : (
          <div>
            <img className={classes.messagePhoto} src={`${process.env.REACT_APP_CDN_HOST}/messages/${message.files[0].path}`} alt={fromUser.firstName}/>
            <Typography variant="caption" className={classes.timeAgoMsg}>
              {moment(new Date(message.createTime).toUTCString()).fromNow()}
            </Typography>
          </div>
        )}
      </div>
    );
  }

  renderNoData() {
    return <Typography>No Messages</Typography>;
  }

  renderMessages() {
    const { classes, data } = this.props;
    return (
      <div className={classes.messagesContainer}>
        <Typography variant="body1" paragraph align="center">
          {data.status.toUpperCase()}
        </Typography>
        <Paper>
          {data.messages.length > 0
            ? data.messages.map(item => this.renderMessageItem(item))
            : this.renderNoData()}
        </Paper>
      </div>
    );
  }

  renderMatch() {
    const { data } = this.props;
    console.log(data);
    return (
      <div>
        {this.renderHeader()}
        {this.renderMessages()}
      </div>
    );
  }

  render() {
    const { loading } = this.props;
    return (
      <Page title="Match Details" loading={loading}>
        {loading ? <div /> : this.renderMatch()}
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.match.loading,
    data: state.match.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: matchId => dispatch(actions.load(matchId))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(Match))
);
